import { render, staticRenderFns } from "./VaimoLoader.vue?vue&type=template&id=3af6ccaf&scoped=true&"
import script from "./VaimoLoader.vue?vue&type=script&lang=js&"
export * from "./VaimoLoader.vue?vue&type=script&lang=js&"
import style0 from "./VaimoLoader.vue?vue&type=style&index=0&id=3af6ccaf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af6ccaf",
  null
  
)

export default component.exports